export default {
  SelectDate: 'Chọn kỳ báo cáo',
  ReportParam: 'Tham số báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  Account: 'Tài khoản',
  Fund: 'Quỹ tiền',
  AccountBank: 'Tài khoản NH, KB',
  PrintDetail: 'In chi tiết',
  VoucherAdj: 'In tháng chỉnh lý quyết toán',
  AllVoucher: 'Bao gồm chứng từ chỉnh lý quyết toán',
  PeriodReport: 'Kỳ báo cáo',
  CheckFormula: 'Kiểm tra công thức',
  showSignKBNN: 'Hiển thị chữ ký xác nhận của bên KBNN'
};